/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_CancellationInputs */

const de_commons_footer_cancellation = /** @type {(inputs: Commons_Footer_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigung`)
};

/** @type {(inputs: Commons_Footer_CancellationInputs) => LocalizedString} */
const en_commons_footer_cancellation = de_commons_footer_cancellation;

/**

* @param {Commons_Footer_CancellationInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_cancellation = /** @type {((inputs?: Commons_Footer_CancellationInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_CancellationInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_cancellation(inputs)
	return en_commons_footer_cancellation(inputs)
});